import { render, staticRenderFns } from "./ReportProblems.vue?vue&type=template&id=0592d55f"
import script from "./ReportProblems.vue?vue&type=script&lang=js"
export * from "./ReportProblems.vue?vue&type=script&lang=js"
import style0 from "./ReportProblems.vue?vue&type=style&index=0&id=0592d55f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports